import type { FC } from 'react';

import { Icon } from '@iconify/react';
import { Chip } from '@mui/material';
import { tss } from 'tss-react/mui';

type Props = {
  factsheetUrl?: string;
};

const useStyles = tss.create(({ theme }) => ({
  chip: {
    '&&:hover': {
      background: theme.palette.action.hover,
      color: 'inherit',
    },
    'cursor': 'pointer',
  },
}));

export const LeanixSourceChip: FC<Props> = ({
  factsheetUrl = 'https://eon.leanix.net/EON/',
}) => {
  const { classes } = useStyles();
  return (
    <Chip
      className={classes.chip}
      clickable
      icon={<Icon icon="mdi:open-in-new" />}
      label="Source: LeanIX"
      onClick={() =>
        window.open(factsheetUrl, '_blank', 'noreferrer noopener')}
      size="small"
      variant="outlined"
    />
  );
};
